import dsv from "./dsv";

var csv = dsv(",");

export var csvParse = csv.parse;
export var csvParseRows = csv.parseRows;
export var csvFormat = csv.format;
export var csvFormatRows = csv.formatRows;



//////////////////
// WEBPACK FOOTER
// ../~/d3-dsv/src/csv.js
// module id = yGbu
// module chunks = 0